import { cn } from "@aichat/ui/lib/utils";

const InstagramIcon = ({
  className,
  filled,
}: {
  className?: string;
  filled?: boolean;
}) => {
  if (filled)
    return (
      <svg
        className={className}
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 24.0547C18.6274 24.0547 24 18.6821 24 12.0547C24 5.42727 18.6274 0.0546875 12 0.0546875C5.37258 0.0546875 0 5.42727 0 12.0547C0 18.6821 5.37258 24.0547 12 24.0547Z"
          fill="url(#paint0_linear_11686_11327)"
        />
        <path
          d="M14.5486 5.38672H9.45522C7.18322 5.38672 5.33789 7.23205 5.33789 9.50405V14.5974C5.33789 16.8694 7.18322 18.7147 9.45522 18.7147H14.5486C16.8206 18.7147 18.6659 16.8694 18.6659 14.5974V9.50405C18.6659 7.23205 16.8206 5.38672 14.5486 5.38672ZM17.1779 14.6027C17.1779 16.0534 15.9992 17.2374 14.5432 17.2374H9.44989C7.99922 17.2374 6.81522 16.0587 6.81522 14.6027V9.50939C6.81522 8.05872 7.99389 6.87472 9.44989 6.87472H14.5432C15.9939 6.87472 17.1779 8.05339 17.1779 9.50939V14.6027Z"
          fill="white"
        />
        <path
          d="M11.9998 8.64453C10.1225 8.64453 8.5918 10.1752 8.5918 12.0525C8.5918 13.9299 10.1225 15.4605 11.9998 15.4605C13.8771 15.4605 15.4078 13.9299 15.4078 12.0525C15.4078 10.1752 13.8771 8.64453 11.9998 8.64453ZM11.9998 14.1219C10.8585 14.1219 9.93046 13.1939 9.93046 12.0525C9.93046 10.9112 10.8585 9.9832 11.9998 9.9832C13.1411 9.9832 14.0691 10.9112 14.0691 12.0525C14.0691 13.1939 13.1411 14.1219 11.9998 14.1219Z"
          fill="white"
        />
        <path
          d="M15.6669 9.01752C15.9809 8.96662 16.1941 8.67083 16.1432 8.35685C16.0923 8.04287 15.7966 7.8296 15.4826 7.8805C15.1686 7.93139 14.9553 8.22719 15.0062 8.54117C15.0571 8.85515 15.3529 9.06842 15.6669 9.01752Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_11686_11327"
            x1="2.86288"
            y1="21.1918"
            x2="19.9162"
            y2="4.13847"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEE411" />
            <stop offset="0.0518459" stop-color="#FEDB16" />
            <stop offset="0.1381" stop-color="#FEC125" />
            <stop offset="0.2481" stop-color="#FE983D" />
            <stop offset="0.3762" stop-color="#FE5F5E" />
            <stop offset="0.5" stop-color="#FE2181" />
            <stop offset="1" stop-color="#9000DC" />
          </linearGradient>
        </defs>
      </svg>
    );

  return (
    <svg
      className={cn(["w-5 h-5", className])}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.23596 10.5C5.23596 7.66393 7.53502 5.36487 10.3711 5.36487C13.2072 5.36487 15.5062 7.66393 15.5062 10.5C15.5062 13.3361 13.2072 15.6351 10.3711 15.6351C7.53502 15.6351 5.23596 13.3361 5.23596 10.5ZM10.3711 13.8333C8.53013 13.8333 7.03776 12.341 7.03776 10.5C7.03776 8.65904 8.53013 7.16667 10.3711 7.16667C12.2121 7.16667 13.7044 8.65904 13.7044 10.5C13.7044 12.341 12.2121 13.8333 10.3711 13.8333Z"
        fill="url(#paint0_linear_340_31750)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.23596 10.5C5.23596 7.66393 7.53502 5.36487 10.3711 5.36487C13.2072 5.36487 15.5062 7.66393 15.5062 10.5C15.5062 13.3361 13.2072 15.6351 10.3711 15.6351C7.53502 15.6351 5.23596 13.3361 5.23596 10.5ZM10.3711 13.8333C8.53013 13.8333 7.03776 12.341 7.03776 10.5C7.03776 8.65904 8.53013 7.16667 10.3711 7.16667C12.2121 7.16667 13.7044 8.65904 13.7044 10.5C13.7044 12.341 12.2121 13.8333 10.3711 13.8333Z"
        fill="url(#paint1_radial_340_31750)"
      />
      <path
        d="M15.7091 6.36197C16.3719 6.36197 16.9091 5.82474 16.9091 5.16199C16.9091 4.49924 16.3719 3.96197 15.7091 3.96197C15.0464 3.96197 14.5091 4.49924 14.5091 5.16199C14.5091 5.82474 15.0464 6.36197 15.7091 6.36197Z"
        fill="url(#paint2_linear_340_31750)"
      />
      <path
        d="M15.7091 6.36197C16.3719 6.36197 16.9091 5.82474 16.9091 5.16199C16.9091 4.49924 16.3719 3.96197 15.7091 3.96197C15.0464 3.96197 14.5091 4.49924 14.5091 5.16199C14.5091 5.82474 15.0464 6.36197 15.7091 6.36197Z"
        fill="url(#paint3_radial_340_31750)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3711 0.5C7.65526 0.5 7.31471 0.511512 6.24811 0.560178C5.18372 0.608725 4.45679 0.777786 3.82071 1.02501C3.16313 1.28052 2.60545 1.62246 2.04948 2.17839C1.49355 2.73436 1.15162 3.29203 0.896101 3.94962C0.64888 4.58569 0.479819 5.31263 0.431271 6.37701C0.382605 7.44362 0.371094 7.78416 0.371094 10.5C0.371094 13.2158 0.382605 13.5564 0.431271 14.623C0.479819 15.6874 0.64888 16.4143 0.896101 17.0504C1.15162 17.708 1.49355 18.2656 2.04948 18.8216C2.60545 19.3775 3.16313 19.7195 3.82071 19.975C4.45679 20.2222 5.18372 20.3913 6.24811 20.4398C7.31471 20.4885 7.65526 20.5 10.3711 20.5C13.0869 20.5 13.4275 20.4885 14.4941 20.4398C15.5585 20.3913 16.2854 20.2222 16.9215 19.975C17.5791 19.7195 18.1367 19.3775 18.6927 18.8216C19.2486 18.2656 19.5906 17.708 19.8461 17.0504C20.0933 16.4143 20.2624 15.6874 20.3109 14.623C20.3596 13.5564 20.3711 13.2158 20.3711 10.5C20.3711 7.78416 20.3596 7.44362 20.3109 6.37701C20.2624 5.31263 20.0933 4.58569 19.8461 3.94962C19.5906 3.29203 19.2486 2.73436 18.6927 2.17839C18.1367 1.62246 17.5791 1.28052 16.9215 1.02501C16.2854 0.777786 15.5585 0.608725 14.4941 0.560178C13.4275 0.511512 13.0869 0.5 10.3711 0.5ZM10.3711 2.3018C13.0412 2.3018 13.3575 2.312 14.412 2.36011C15.3869 2.40457 15.9164 2.56748 16.2688 2.70443C16.7356 2.88583 17.0687 3.10253 17.4186 3.45248C17.7686 3.80239 17.9853 4.13551 18.1667 4.60229C18.3036 4.95466 18.4665 5.48415 18.511 6.45914C18.5591 7.5136 18.5693 7.82989 18.5693 10.5C18.5693 13.1701 18.5591 13.4864 18.511 14.5409C18.4665 15.5158 18.3036 16.0453 18.1667 16.3977C17.9853 16.8645 17.7686 17.1976 17.4186 17.5475C17.0687 17.8975 16.7356 18.1142 16.2688 18.2956C15.9164 18.4325 15.3869 18.5954 14.412 18.6399C13.3577 18.688 13.0414 18.6982 10.3711 18.6982C7.70079 18.6982 7.38458 18.688 6.33024 18.6399C5.35525 18.5954 4.82576 18.4325 4.47338 18.2956C4.00661 18.1142 3.67349 17.8975 3.32358 17.5475C2.97366 17.1976 2.75693 16.8645 2.57552 16.3977C2.43857 16.0453 2.27567 15.5158 2.23121 14.5409C2.1831 13.4864 2.17289 13.1701 2.17289 10.5C2.17289 7.82989 2.1831 7.5136 2.23121 6.45914C2.27567 5.48415 2.43857 4.95466 2.57552 4.60229C2.75693 4.13551 2.97362 3.80239 3.32358 3.45248C3.67349 3.10253 4.00661 2.88583 4.47338 2.70443C4.82576 2.56748 5.35525 2.40457 6.33024 2.36011C7.3847 2.312 7.70099 2.3018 10.3711 2.3018Z"
        fill="url(#paint4_linear_340_31750)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3711 0.5C7.65526 0.5 7.31471 0.511512 6.24811 0.560178C5.18372 0.608725 4.45679 0.777786 3.82071 1.02501C3.16313 1.28052 2.60545 1.62246 2.04948 2.17839C1.49355 2.73436 1.15162 3.29203 0.896101 3.94962C0.64888 4.58569 0.479819 5.31263 0.431271 6.37701C0.382605 7.44362 0.371094 7.78416 0.371094 10.5C0.371094 13.2158 0.382605 13.5564 0.431271 14.623C0.479819 15.6874 0.64888 16.4143 0.896101 17.0504C1.15162 17.708 1.49355 18.2656 2.04948 18.8216C2.60545 19.3775 3.16313 19.7195 3.82071 19.975C4.45679 20.2222 5.18372 20.3913 6.24811 20.4398C7.31471 20.4885 7.65526 20.5 10.3711 20.5C13.0869 20.5 13.4275 20.4885 14.4941 20.4398C15.5585 20.3913 16.2854 20.2222 16.9215 19.975C17.5791 19.7195 18.1367 19.3775 18.6927 18.8216C19.2486 18.2656 19.5906 17.708 19.8461 17.0504C20.0933 16.4143 20.2624 15.6874 20.3109 14.623C20.3596 13.5564 20.3711 13.2158 20.3711 10.5C20.3711 7.78416 20.3596 7.44362 20.3109 6.37701C20.2624 5.31263 20.0933 4.58569 19.8461 3.94962C19.5906 3.29203 19.2486 2.73436 18.6927 2.17839C18.1367 1.62246 17.5791 1.28052 16.9215 1.02501C16.2854 0.777786 15.5585 0.608725 14.4941 0.560178C13.4275 0.511512 13.0869 0.5 10.3711 0.5ZM10.3711 2.3018C13.0412 2.3018 13.3575 2.312 14.412 2.36011C15.3869 2.40457 15.9164 2.56748 16.2688 2.70443C16.7356 2.88583 17.0687 3.10253 17.4186 3.45248C17.7686 3.80239 17.9853 4.13551 18.1667 4.60229C18.3036 4.95466 18.4665 5.48415 18.511 6.45914C18.5591 7.5136 18.5693 7.82989 18.5693 10.5C18.5693 13.1701 18.5591 13.4864 18.511 14.5409C18.4665 15.5158 18.3036 16.0453 18.1667 16.3977C17.9853 16.8645 17.7686 17.1976 17.4186 17.5475C17.0687 17.8975 16.7356 18.1142 16.2688 18.2956C15.9164 18.4325 15.3869 18.5954 14.412 18.6399C13.3577 18.688 13.0414 18.6982 10.3711 18.6982C7.70079 18.6982 7.38458 18.688 6.33024 18.6399C5.35525 18.5954 4.82576 18.4325 4.47338 18.2956C4.00661 18.1142 3.67349 17.8975 3.32358 17.5475C2.97366 17.1976 2.75693 16.8645 2.57552 16.3977C2.43857 16.0453 2.27567 15.5158 2.23121 14.5409C2.1831 13.4864 2.17289 13.1701 2.17289 10.5C2.17289 7.82989 2.1831 7.5136 2.23121 6.45914C2.27567 5.48415 2.43857 4.95466 2.57552 4.60229C2.75693 4.13551 2.97362 3.80239 3.32358 3.45248C3.67349 3.10253 4.00661 2.88583 4.47338 2.70443C4.82576 2.56748 5.35525 2.40457 6.33024 2.36011C7.3847 2.312 7.70099 2.3018 10.3711 2.3018Z"
        fill="url(#paint5_radial_340_31750)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_340_31750"
          x1="1.53803"
          y1="1.55146"
          x2="7.84386"
          y2="25.9432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E60D3" />
          <stop offset="0.142763" stopColor="#913BAF" />
          <stop offset="0.761458" stopColor="#D52D88" />
          <stop offset="1" stopColor="#F26D4F" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_340_31750"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.42596 20.5) rotate(32.1601) scale(18.6789 13.4426)"
        >
          <stop stopColor="#FED276" />
          <stop offset="0.17024" stopColor="#FDBD61" stopOpacity="0.975006" />
          <stop offset="0.454081" stopColor="#F6804D" />
          <stop offset="1" stopColor="#E83D5C" stopOpacity="0.01" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_340_31750"
          x1="1.53803"
          y1="1.55146"
          x2="7.84386"
          y2="25.9432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E60D3" />
          <stop offset="0.142763" stopColor="#913BAF" />
          <stop offset="0.761458" stopColor="#D52D88" />
          <stop offset="1" stopColor="#F26D4F" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_340_31750"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.42596 20.5) rotate(32.1601) scale(18.6789 13.4426)"
        >
          <stop stopColor="#FED276" />
          <stop offset="0.17024" stopColor="#FDBD61" stopOpacity="0.975006" />
          <stop offset="0.454081" stopColor="#F6804D" />
          <stop offset="1" stopColor="#E83D5C" stopOpacity="0.01" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_340_31750"
          x1="1.53803"
          y1="1.55146"
          x2="7.84386"
          y2="25.9432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E60D3" />
          <stop offset="0.142763" stopColor="#913BAF" />
          <stop offset="0.761458" stopColor="#D52D88" />
          <stop offset="1" stopColor="#F26D4F" />
        </linearGradient>
        <radialGradient
          id="paint5_radial_340_31750"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.42596 20.5) rotate(32.1601) scale(18.6789 13.4426)"
        >
          <stop stopColor="#FED276" />
          <stop offset="0.17024" stopColor="#FDBD61" stopOpacity="0.975006" />
          <stop offset="0.454081" stopColor="#F6804D" />
          <stop offset="1" stopColor="#E83D5C" stopOpacity="0.01" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default InstagramIcon;
